import React from 'react';
import '../styles.css';
import { useShopInfo } from '../settings/SettingsContext';

const translations = {
  en: {
    title: 'ORDER ONLINE',
    subtitle: 'Available on delivery platforms',
  },
  gr: {
    title: 'ΠΑΡΑΓΓΕΙΛΕ ONLINE',
    subtitle: 'Διαθέσιμο σε πλατφόρμες delivery',
  },
};

interface DeliveryButtonsProps {
  selectedLanguage: 'gr' | 'en';
}

const DeliveryButtons: React.FC<DeliveryButtonsProps> = ({ selectedLanguage }) => {
  const info = useShopInfo();
  const efoodLink = info.efoodLink ?? process.env.REACT_APP_EFOOD_LINK ?? '';
  const woltLink = info.woltLink ?? process.env.REACT_APP_WOLT_LINK ?? '';
  const boxLink = info.boxLink ?? process.env.REACT_APP_BOX_LINK ?? '';

  const t = translations[selectedLanguage];
  const hasAnyLink = efoodLink || woltLink || boxLink;

  if (!hasAnyLink) return null;

  return (
    <div className="delivery-container">
      <h2 className="delivery-title">{t.title}</h2>
      <p className="delivery-subtitle">{t.subtitle}</p>

      <div className="delivery-buttons-grid">
        {efoodLink && (
          <a href={efoodLink} target="_blank" rel="noopener noreferrer" className="delivery-button delivery-button-efood">
            <span className="delivery-button-text">e-food</span>
          </a>
        )}
        {woltLink && (
          <a href={woltLink} target="_blank" rel="noopener noreferrer" className="delivery-button delivery-button-wolt">
            <span className="delivery-button-text">Wolt</span>
          </a>
        )}
        {boxLink && (
          <a href={boxLink} target="_blank" rel="noopener noreferrer" className="delivery-button delivery-button-box">
            <span className="delivery-button-text">Box</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default DeliveryButtons;
